module.exports = __webpack_public_path__ + "img/Rectangle 22.f024b714.png";